/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetPowerBiReportsParams,
  PowerBiExportDto,
  PowerBiExportRequest,
  PowerBiReportDto,
  PowerBiTokenDto,
  PowerBiTokenRequest
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType , BodyType } from '../../orval-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Authorities: **Any authenticated role**
 */
export const getPowerBiTokenForReport = (
    userId: string,
    powerbiReportId: string,
    powerBiTokenRequest?: BodyType<PowerBiTokenRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PowerBiTokenDto>(
      {url: `/api/${userId}/powerbi/token/${powerbiReportId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: powerBiTokenRequest, signal
    },
      options);
    }



export const getGetPowerBiTokenForReportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPowerBiTokenForReport>>, TError,{userId: string;powerbiReportId: string;data?: BodyType<PowerBiTokenRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof getPowerBiTokenForReport>>, TError,{userId: string;powerbiReportId: string;data?: BodyType<PowerBiTokenRequest>}, TContext> => {

const mutationKey = ['getPowerBiTokenForReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPowerBiTokenForReport>>, {userId: string;powerbiReportId: string;data?: BodyType<PowerBiTokenRequest>}> = (props) => {
          const {userId,powerbiReportId,data} = props ?? {};

          return  getPowerBiTokenForReport(userId,powerbiReportId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetPowerBiTokenForReportMutationResult = NonNullable<Awaited<ReturnType<typeof getPowerBiTokenForReport>>>
    export type GetPowerBiTokenForReportMutationBody = BodyType<PowerBiTokenRequest> | undefined
    export type GetPowerBiTokenForReportMutationError = ErrorType<unknown>

    export const useGetPowerBiTokenForReport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPowerBiTokenForReport>>, TError,{userId: string;powerbiReportId: string;data?: BodyType<PowerBiTokenRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getPowerBiTokenForReport>>,
        TError,
        {userId: string;powerbiReportId: string;data?: BodyType<PowerBiTokenRequest>},
        TContext
      > => {
      return useMutation(getGetPowerBiTokenForReportMutationOptions(options), queryClient);
    }
    /**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_CLIENT_SERVICE, ROLE_FD_PRINCIPAL**<br /><br />
 * @summary Start export report to file job
 */
export const exportPowerBiReportToFile = (
    userId: string,
    powerBiReportId: string,
    powerBiExportRequest: BodyType<PowerBiExportRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PowerBiExportDto>(
      {url: `/api/${userId}/powerbi/reports/${powerBiReportId}/exports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: powerBiExportRequest, signal
    },
      options);
    }



export const getExportPowerBiReportToFileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportPowerBiReportToFile>>, TError,{userId: string;powerBiReportId: string;data: BodyType<PowerBiExportRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof exportPowerBiReportToFile>>, TError,{userId: string;powerBiReportId: string;data: BodyType<PowerBiExportRequest>}, TContext> => {

const mutationKey = ['exportPowerBiReportToFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportPowerBiReportToFile>>, {userId: string;powerBiReportId: string;data: BodyType<PowerBiExportRequest>}> = (props) => {
          const {userId,powerBiReportId,data} = props ?? {};

          return  exportPowerBiReportToFile(userId,powerBiReportId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExportPowerBiReportToFileMutationResult = NonNullable<Awaited<ReturnType<typeof exportPowerBiReportToFile>>>
    export type ExportPowerBiReportToFileMutationBody = BodyType<PowerBiExportRequest>
    export type ExportPowerBiReportToFileMutationError = ErrorType<unknown>

    /**
 * @summary Start export report to file job
 */
export const useExportPowerBiReportToFile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportPowerBiReportToFile>>, TError,{userId: string;powerBiReportId: string;data: BodyType<PowerBiExportRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof exportPowerBiReportToFile>>,
        TError,
        {userId: string;powerBiReportId: string;data: BodyType<PowerBiExportRequest>},
        TContext
      > => {
      return useMutation(getExportPowerBiReportToFileMutationOptions(options), queryClient);
    }
    /**
 * Authorities: **ROLE_SUPER_ADMIN**<br /><br />
 * @summary Returns powerbi reports sorted by name
 */
export const getPowerBiReports = (
    userId: string,
    params?: GetPowerBiReportsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PowerBiReportDto[]>(
      {url: `/api/${userId}/powerbi/reports`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPowerBiReportsQueryKey = (userId: string,
    params?: GetPowerBiReportsParams,) => {
    return [
    `/api/${userId}/powerbi/reports`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPowerBiReportsQueryOptions = <TData = Awaited<ReturnType<typeof getPowerBiReports>>, TError = ErrorType<unknown>>(userId: string,
    params?: GetPowerBiReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerBiReports>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPowerBiReportsQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPowerBiReports>>> = ({ signal }) => getPowerBiReports(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPowerBiReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPowerBiReportsQueryResult = NonNullable<Awaited<ReturnType<typeof getPowerBiReports>>>
export type GetPowerBiReportsQueryError = ErrorType<unknown>


export function useGetPowerBiReports<TData = Awaited<ReturnType<typeof getPowerBiReports>>, TError = ErrorType<unknown>>(
 userId: string,
    params: undefined |  GetPowerBiReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerBiReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPowerBiReports>>,
          TError,
          Awaited<ReturnType<typeof getPowerBiReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPowerBiReports<TData = Awaited<ReturnType<typeof getPowerBiReports>>, TError = ErrorType<unknown>>(
 userId: string,
    params?: GetPowerBiReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerBiReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPowerBiReports>>,
          TError,
          Awaited<ReturnType<typeof getPowerBiReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPowerBiReports<TData = Awaited<ReturnType<typeof getPowerBiReports>>, TError = ErrorType<unknown>>(
 userId: string,
    params?: GetPowerBiReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerBiReports>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns powerbi reports sorted by name
 */

export function useGetPowerBiReports<TData = Awaited<ReturnType<typeof getPowerBiReports>>, TError = ErrorType<unknown>>(
 userId: string,
    params?: GetPowerBiReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerBiReports>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPowerBiReportsQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_CLIENT_SERVICE, ROLE_FD_PRINCIPAL**<br /><br />
 * @summary Check Power Bi export job status
 */
export const getPowerBiReportExportStatus = (
    userId: string,
    powerBiReportId: string,
    exportId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PowerBiExportDto>(
      {url: `/api/${userId}/powerbi/reports/${powerBiReportId}/exports/${exportId}`, method: 'GET', signal
    },
      options);
    }




export const getGetPowerBiReportExportStatusQueryKey = (userId: string,
    powerBiReportId: string,
    exportId: string,) => {
    return [
    `/api/${userId}/powerbi/reports/${powerBiReportId}/exports/${exportId}`
    ] as const;
    }


export const getGetPowerBiReportExportStatusQueryOptions = <TData = Awaited<ReturnType<typeof getPowerBiReportExportStatus>>, TError = ErrorType<unknown>>(userId: string,
    powerBiReportId: string,
    exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerBiReportExportStatus>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPowerBiReportExportStatusQueryKey(userId,powerBiReportId,exportId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPowerBiReportExportStatus>>> = ({ signal }) => getPowerBiReportExportStatus(userId,powerBiReportId,exportId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId && powerBiReportId && exportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPowerBiReportExportStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPowerBiReportExportStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getPowerBiReportExportStatus>>>
export type GetPowerBiReportExportStatusQueryError = ErrorType<unknown>


export function useGetPowerBiReportExportStatus<TData = Awaited<ReturnType<typeof getPowerBiReportExportStatus>>, TError = ErrorType<unknown>>(
 userId: string,
    powerBiReportId: string,
    exportId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerBiReportExportStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPowerBiReportExportStatus>>,
          TError,
          Awaited<ReturnType<typeof getPowerBiReportExportStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPowerBiReportExportStatus<TData = Awaited<ReturnType<typeof getPowerBiReportExportStatus>>, TError = ErrorType<unknown>>(
 userId: string,
    powerBiReportId: string,
    exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerBiReportExportStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPowerBiReportExportStatus>>,
          TError,
          Awaited<ReturnType<typeof getPowerBiReportExportStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPowerBiReportExportStatus<TData = Awaited<ReturnType<typeof getPowerBiReportExportStatus>>, TError = ErrorType<unknown>>(
 userId: string,
    powerBiReportId: string,
    exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerBiReportExportStatus>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check Power Bi export job status
 */

export function useGetPowerBiReportExportStatus<TData = Awaited<ReturnType<typeof getPowerBiReportExportStatus>>, TError = ErrorType<unknown>>(
 userId: string,
    powerBiReportId: string,
    exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPowerBiReportExportStatus>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPowerBiReportExportStatusQueryOptions(userId,powerBiReportId,exportId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_CLIENT_SERVICE, ROLE_FD_PRINCIPAL**<br /><br />
 * @summary Download Power Bi report as file
 */
export const downloadPowerBiReportFile = (
    userId: string,
    powerBiReportId: string,
    exportId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Blob>(
      {url: `/api/${userId}/powerbi/reports/${powerBiReportId}/exports/${exportId}/download`, method: 'GET', signal
    },
      options);
    }




export const getDownloadPowerBiReportFileQueryKey = (userId: string,
    powerBiReportId: string,
    exportId: string,) => {
    return [
    `/api/${userId}/powerbi/reports/${powerBiReportId}/exports/${exportId}/download`
    ] as const;
    }


export const getDownloadPowerBiReportFileQueryOptions = <TData = Awaited<ReturnType<typeof downloadPowerBiReportFile>>, TError = ErrorType<unknown>>(userId: string,
    powerBiReportId: string,
    exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadPowerBiReportFile>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadPowerBiReportFileQueryKey(userId,powerBiReportId,exportId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadPowerBiReportFile>>> = ({ signal }) => downloadPowerBiReportFile(userId,powerBiReportId,exportId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId && powerBiReportId && exportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadPowerBiReportFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadPowerBiReportFileQueryResult = NonNullable<Awaited<ReturnType<typeof downloadPowerBiReportFile>>>
export type DownloadPowerBiReportFileQueryError = ErrorType<unknown>


export function useDownloadPowerBiReportFile<TData = Awaited<ReturnType<typeof downloadPowerBiReportFile>>, TError = ErrorType<unknown>>(
 userId: string,
    powerBiReportId: string,
    exportId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadPowerBiReportFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadPowerBiReportFile>>,
          TError,
          Awaited<ReturnType<typeof downloadPowerBiReportFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadPowerBiReportFile<TData = Awaited<ReturnType<typeof downloadPowerBiReportFile>>, TError = ErrorType<unknown>>(
 userId: string,
    powerBiReportId: string,
    exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadPowerBiReportFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadPowerBiReportFile>>,
          TError,
          Awaited<ReturnType<typeof downloadPowerBiReportFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadPowerBiReportFile<TData = Awaited<ReturnType<typeof downloadPowerBiReportFile>>, TError = ErrorType<unknown>>(
 userId: string,
    powerBiReportId: string,
    exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadPowerBiReportFile>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download Power Bi report as file
 */

export function useDownloadPowerBiReportFile<TData = Awaited<ReturnType<typeof downloadPowerBiReportFile>>, TError = ErrorType<unknown>>(
 userId: string,
    powerBiReportId: string,
    exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadPowerBiReportFile>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadPowerBiReportFileQueryOptions(userId,powerBiReportId,exportId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






